var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSixDotBlueBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 30,
    viewBox: "0 0 16 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 30,
    fill: "#DAE5F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.2,
    cy: 10.2,
    r: 1.2,
    fill: "#203662"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.60039,
    cy: 10.2,
    r: 1.2,
    fill: "#203662"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.2,
    cy: 14.6004,
    r: 1.2,
    fill: "#203662"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.60039,
    cy: 14.6004,
    r: 1.2,
    fill: "#203662"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.2,
    cy: 19.0008,
    r: 1.2,
    fill: "#203662"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.60039,
    cy: 19.0008,
    r: 1.2,
    fill: "#203662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixDotBlueBg);
export default __webpack_public_path__ + "static/media/sixDotBlueBg.e87351f9542d68afcffa3290bdaa2a16.svg";
export { ForwardRef as ReactComponent };